import React, { useEffect, useState } from 'react'
import { Button, Radio, DatePicker, Dropdown, TimePicker } from 'components/UIElements'
import STRINGS from 'utils/strings'
import {
  STATUS_OPTIONS,
  DATE_FORMAT_MAP,
  VISIT_START_HOUR,
  VISIT_START_MINUTE,
  VISIT_START_SECOND,
  NOT_APPLICABLE,
} from 'utils/constants'
import moment from 'moment'
import '../stylesheets/VisitTable.scss'
import '../stylesheets/VisitSchedules.scss'

const MISSED_VISIT_REASON_OPTIONS = [
  {
    key: 'Patient is physically or mentally unable to complete the questionnaire/assessment',
    text: 'Patient is physically or mentally unable to complete the questionnaire/assessment',
  },
  {
    key: 'Questionnaire not administered to Patient by site staff',
    text: 'Questionnaire not administered to Patient by site staff',
  },
  { key: 'Equipment Malfunction/Paper Collected', text: 'Equipment Malfunction/Paper Collected' },
  { key: 'Patient Refused', text: 'Patient Refused' },
  { key: 'Parent/Guardian Refused', text: 'Parent/Guardian Refused' },
  { key: 'Visit postponed due to dosing delay', text: 'Visit postponed due to dosing delay' },
  { key: 'Other', text: 'Other' },
]

const DEFAULT_TIME = { hour: VISIT_START_HOUR, minute: VISIT_START_MINUTE, second: VISIT_START_SECOND }

const UpdateStatusSection = ({
  actualDate,
  isScheduleDateFuture,
  status,
  statusReasonValue,
  studyID,
  ssvId,
  ptpID,
  onClose,
  updatePreviousScheduleVisit,
  heading,
  scheduledDate,
  requireMissedVisitReason,
  isCollectConfirmedTime,
  actualTime,
}) => {
  // Initialize statusOption to null if no status is provided or status is not a valid option (Confirmed/Missed),
  // so user must explicitly select an option
  const [statusOption, setStatusOption] = useState(
    status === STATUS_OPTIONS.Confirmed || status === STATUS_OPTIONS.Missed ? status : null
  )
  const [date, setDate] = useState(() => {
    if (isScheduleDateFuture) {
      return new Date(actualDate || scheduledDate.value)
    }
    return new Date()
  })
  const [currentTime, setCurrentTime] = useState(() => {
    return actualTime ? moment(new Date(actualTime)) : moment().set(DEFAULT_TIME)
  })

  const [selectedMissedVisitReason, setSelectedMissedVisitReason] = useState(MISSED_VISIT_REASON_OPTIONS[0])

  useEffect(() => {
    if (statusReasonValue) {
      setSelectedMissedVisitReason({
        key: statusReasonValue,
        text: statusReasonValue,
      })
    }
  }, [statusReasonValue])

  const onChangeTime = mom => {
    setCurrentTime(mom)
  }
  const getUpdateStatusTimePopupContainer = triggerNode =>
    triggerNode?.closest('.actual-visit-time-wrapper') || triggerNode?.parentNode || document.body
  const getTimeObj = () =>
    isCollectConfirmedTime
      ? {
        hour: currentTime.hours(),
        minute: currentTime.minutes(),
        second: VISIT_START_SECOND,
      }
      : DEFAULT_TIME
  return (
    <>
      {heading ? <p className='heading'>{heading}</p> : null}
      {isScheduleDateFuture ? (
        <>
          <p className='caption'>{STRINGS.pleaseConfirmUpcomingDate}</p>
          <div className='checkbox-wrapper'>
            <Radio
              selected={statusOption === STATUS_OPTIONS.Confirmed}
              content={STRINGS.visitConfirmedOnDay}
              onClick={() => {
                setStatusOption(STATUS_OPTIONS.Confirmed)
              }}
            />
          </div>
          {statusOption === STATUS_OPTIONS.Confirmed ? (
            <div className='actual-visit-date-time'>
              <div className='actual-visit-date-wrapper'>
                <label className='label-small' htmlFor='actual-visit-date'>
                  {STRINGS.actualVisitDate}
                </label>
                <DatePicker
                  id='actual-visit-date'
                  className='actual-visit-date-picker'
                  date={moment(date)}
                  disabledDays={{
                    before: new Date(),
                  }}
                  onDayChange={date => {
                    setDate(date)
                  }}
                  value={date}
                />
              </div>
              {isCollectConfirmedTime && (
                <div className='actual-visit-time-wrapper'>
                  <label className='label-small' htmlFor='actual-visit-time'>
                    {STRINGS.actualVisitTime}
                  </label>
                  <TimePicker
                    allowEmpty={false}
                    format='HH:mm'
                    value={currentTime}
                    onChange={onChangeTime}
                    getPopupContainer={getUpdateStatusTimePopupContainer}
                  />
                </div>
              )}
            </div>
          ) : null}
        </>
      ) : (
        <>
          <p className='caption'>{STRINGS.pleaseConfirmActualDate}</p>
          <div className='checkbox-wrapper'>
            <Radio
              selected={statusOption === STATUS_OPTIONS.Confirmed}
              content={STRINGS.visitOccurred}
              onClick={() => {
                setStatusOption(STATUS_OPTIONS.Confirmed)
              }}
            />
          </div>
          {statusOption === STATUS_OPTIONS.Confirmed && (
            <div className='actual-visit-date-time'>
              <div className='actual-visit-date-wrapper'>
                <label className='label-small' htmlFor='actual-visit-date'>
                  {STRINGS.actualVisitDate}
                </label>
                <DatePicker
                  id='actual-visit-date'
                  className='actual-visit-date-picker'
                  date={moment(date)}
                  disabledDays={{
                    after: new Date(),
                  }}
                  onDayChange={date => {
                    setDate(date)
                  }}
                  value={date}
                />
              </div>
              {isCollectConfirmedTime && (
                <div className='actual-visit-time-wrapper'>
                  <label className='label-small' htmlFor='actual-visit-time'>
                    {STRINGS.actualVisitTime}
                  </label>
                  <TimePicker
                    allowEmpty={false}
                    format='HH:mm'
                    value={currentTime}
                    onChange={onChangeTime}
                    getPopupContainer={getUpdateStatusTimePopupContainer}
                  />
                </div>
              )}
            </div>
          )}
          <div className='checkbox-wrapper'>
            <Radio
              selected={statusOption === STATUS_OPTIONS.Missed}
              content={STRINGS.visitMissed}
              onClick={() => {
                setStatusOption(STATUS_OPTIONS.Missed)
              }}
            />
          </div>
            {requireMissedVisitReason && statusOption === STATUS_OPTIONS.Missed ? (
            <div className='actual-visit-date-wrapper'>
              <label className='label-small' htmlFor='actual-visit-date'>
                {STRINGS.missedVisitReason}
              </label>
              <Dropdown
                className='missed-visit-reason-dropdown'
                options={MISSED_VISIT_REASON_OPTIONS}
                onSelect={item => {
                  setSelectedMissedVisitReason(item)
                }}
                selected={selectedMissedVisitReason.key}
              />
            </div>
          ) : null}
        </>
      )}
      <div className='bottom flexed'>
        <Button grey id='modal-cancel' content='Cancel' onClick={onClose} />
        <Button
          id='modal-confirm'
          className='confirm'
          content='Confirm'
          disabled={!statusOption}
          onClick={() => {
            onClose()
            const requestBody = {
              actual_visit_datetime:
                statusOption === STATUS_OPTIONS.Confirmed
                  ? moment(date)
                    .set(getTimeObj())
                    .format(DATE_FORMAT_MAP.datePickerWithFullTime)
                  : undefined,
              status: statusOption,
            }

            // Only send status_reason for Missed status cases
            if (statusOption === STATUS_OPTIONS.Missed && requireMissedVisitReason) {
              // Default to "Not Applicable" if empty
              requestBody.status_reason = selectedMissedVisitReason?.text || NOT_APPLICABLE
            }

            updatePreviousScheduleVisit(studyID, ssvId, ptpID, requestBody)
          }}
        />
      </div>
    </>
  )
}

export default UpdateStatusSection
